import ReactWhatsapp from 'react-whatsapp';
import styled from 'styled-components';

import { COLORS } from 'styles/constants';

export const TwoNumberContainer = styled.div`
  display: flex;

  > button {
    height: 60px;
    width: 160px;
    padding: 5px;

    font-size: 19px;
  }
`;

export const WhatsappButton = styled(ReactWhatsapp)`
  margin-top: 25px;
  padding: 12px;
  width: 230px;

  color: ${COLORS.white};
  font-size: 22px;
  border: 3px solid rgba(0, 0, 0, 0);
  border-radius: 5px;
  background: #075e54;

  transition: border 0.2s;

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  &:hover {
    border: 3px solid ${COLORS.white};
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    margin-top: 20px;
    padding: 20px;
    font-size: 2vh;
  }
`;

export const PhoneBoxButton = styled.button`
  margin-top: 25px;
  padding: 12px;
  width: 230px;

  color: ${COLORS.white};
  font-size: 22px;
  border: none;
  border-radius: 5px;
  background: ${COLORS.darkBackground};

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  @media all and (min-width: 600px) and (max-width: 1200px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    margin-top: 20px;
    padding: 20px;
    font-size: 2vh;
    width: 50%;
  }
`;
